import Addon from './Addon';

export default class AddonList {
  checkin!: string;
  checkout!: string;
  items!: Addon[];

  constructor(data: undefined | any = {}) {
    this.items = [];
    if (!data.success || !data?.data) return;

    const addonData = data.data;
    const keys = Object.keys(addonData);

    for (let i = 0; i < keys.length; i++) {
      const keyParts = keys[i].split('-');

      const roomId = parseInt(keyParts[0]);
      const packageId = parseInt(keyParts[1]);
      const checkin = keyParts[2] + '-' + keyParts[3] + '-' + keyParts[4];
      const checkout = keyParts[5] + '-' + keyParts[6] + '-' + keyParts[7];
      const adults = parseInt(keyParts[8]);
      const kids = parseInt(keyParts[9]);

      this.checkin = checkin;
      this.checkout = checkout;

      const addons = Object.keys(addonData[keys[i]]);
      for (let j = 0; j < addons.length; j++) {
        const addonRawData = {
          ...addonData[keys[i]][addons[j]],
          packageId,
          roomId,
          checkin,
          checkout,
          adults,
          kids,
        };

        this.items.push(new Addon(addonRawData));
      }
    }

    if (data?.items) {
      for (let i = 0; i < data.items.length; i++) {
        this.items.push(new Addon(data.items[i]));
      }
    }
  }
}
